import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/Reveal";

export function Breadcrumb({ items }) {
  return (
    <nav data-testid="breadcrumb" className="flex items-center gap-1.5 text-xs font-semibold text-white/50 mb-6 flex-wrap">
      <Link to="/" className="hover:text-aqua transition-colors">Accueil</Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight size={12} />
          {it.to ? (
            <Link to={it.to} className="hover:text-aqua transition-colors">{it.label}</Link>
          ) : (
            <span className="text-aqua">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default function PageHero({ overline, titleLines, subtitle, breadcrumb }) {
  return (
    <section className="relative bg-ink pt-[76px] overflow-hidden grain">
      <div className="absolute -top-20 right-0 h-80 w-80 rounded-full bg-aqua/20 blur-3xl" />
      <div className="container-x py-16 sm:py-24 relative z-10">
        {breadcrumb && <Breadcrumb items={breadcrumb} />}
        {overline && <p className="overline text-aqua mb-5">{overline}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white leading-[1.05]">
          <MaskedLines lines={titleLines} />
        </h1>
        {subtitle && (
          <Reveal delay={0.3} className="mt-6 max-w-2xl text-lg text-white/70">
            {subtitle}
          </Reveal>
        )}
      </div>
    </section>
  );
}
